var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderMoon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.00004C10 10.866 13.134 14 17 14C18.635 14 20.1391 13.4395 21.3306 12.5C21.36 12.4768 21.3893 12.4533 21.4184 12.4297C21.6445 12.2454 21.9966 12.395 21.9768 12.686C21.6244 17.8888 17.2923 22 12 22C6.47715 22 2 17.5228 2 12C2 6.87306 5.85833 2.64724 10.8298 2.06779C10.967 2.0518 11.09 2.03936 11.2019 2.02974C11.534 2.0012 11.7063 2.40774 11.5 2.66945C10.5606 3.86092 10 5.36502 10 7.00004ZM4 12C4 16.4183 7.58172 20 12 20C15.0583 20 17.7158 18.2839 19.062 15.7621C18.3945 15.9187 17.7035 16 17 16C12.0294 16 8 11.9706 8 7.00004C8 6.29653 8.08133 5.60552 8.2379 4.93805C5.71611 6.28428 4 8.94174 4 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMoon);
export default __webpack_public_path__ + "static/media/header_moon.9aafbd277f3f042188ad4fe3225e91ae.svg";
export { ForwardRef as ReactComponent };